import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import type { SearchMode } from '@/features/search/types';
import { tabNavFlexActiveClassName, tabNavFlexInactiveClassName } from '@/shared/config/theme';

interface SearchModeToggleProps {
  activeMode: SearchMode;
  onChange: (mode: SearchMode) => void;
}

const MODES: readonly { id: SearchMode; labelKey: 'tabUsers' | 'tabClasses' }[] = [
  { id: 'users', labelKey: 'tabUsers' },
  { id: 'classes', labelKey: 'tabClasses' },
];

export default function SearchModeToggle({ activeMode, onChange }: SearchModeToggleProps) {
  const { t } = useTranslation('search');

  return (
    <div className="flex border-b border-gray-300" role="tablist" aria-label={t('resultTypeAria')}>
      {MODES.map((mode) => {
        const isActive = activeMode === mode.id;
        return (
          <button
            key={mode.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(mode.id)}
            className={clsx(
              'flex-1',
              isActive ? tabNavFlexActiveClassName : tabNavFlexInactiveClassName,
            )}
          >
            {t(mode.labelKey)}
          </button>
        );
      })}
    </div>
  );
}
